export const PhotoCaptureScriptQuestionIds = {
    ID_TNC_CHECKBOX: 'tncCheckboxId',
    ID_DECLINE_DIV: 'divDeclineId',
    ID_DECLINE_SPAN: 'scriptQuestionDecline',
    ID_PREVIOUS_BUTTON: 'prevBtnId',
    ID_NEXT_BUTTON: 'nextBtnId',
    ID_BACK_BUTTON: 'backBtnId',
    ID_PROCEED_BUTTON: 'proceedBtnId',
    ID_SCRIPT_QUESTION_BUTTON: 'scriptQuestionBtnId',
    ID_TOPCLOSEUP_IMAGE: 'topCloseUpImage',
    ID_TOPCLOSEUP_UPLOADBUTTON: 'topCloseUpButton',
    ID_CENTERCLOSEUP_IMAGE: 'centerCloseUpImage',
    ID_CENTERCLOSEUP_UPLOADBUTTON: 'centerCloseUpButton',
    ID_BOTTOMCLOSEUP_IMAGE: 'bottomCloseUpImage',
    ID_BOTTOMCLOSEUP_UPLOADBUTTON: 'bottomCloseUpButton',
    ID_TOP_LEFT_CORNER_IMAGE: 'topLeftCornerImage',
    ID_TOP_LEFT_CORNER_BUTTON: 'topLeftCornerButton',
    ID_TOP_RIGHT_CORNER_IMAGE: 'topRightCornerImage',
    ID_TOP_RIGHT_CORNER_BUTTON: 'topRightCornerButton',
    ID_BOTTOM_LEFT_CORNER_IMAGE: 'bottomLeftCornerImage',
    ID_BOTTOM_LEFT_CORNER_BUTTON: 'bottomLeftCornerButton',
    ID_BOTTOM_RIGHT_CORNER_IMAGE: 'bottomRightCornerImage',
    ID_BOTTOM_RIGHT_CORNER_BUTTON: 'bottomRightCornerButton',
    ID_ADDITIONAL_PHOTOS_NAVIGATION_CONTROL: 'additionalPhotosControl',
    ID_I_UNSERSTAND_FRAUD_WARNING: 'iUnderstandFraudWarning',
    ID_DAMAGE_PANEL_BUTTON_PARENT: 'damagePanelButtonParent',
    ID_DAMAGE_PANEL_BUTTON_CHILD: 'damagePanelButtonChild'
};
//# sourceMappingURL=PhotoCaptureIds.js.map